import { Flex } from '../../../ui';
import {
	MainInformation,
	WidgetContent,
} from '../../shared/components/widget/WidgetContainer';
import { ISecurityCheckpoint } from '../domain/models/ISecurityCheckpoint';
import { GATES_RANGES } from '../hooks/useGetCheckpointsData';
import {
	MoreInformationButton,
	MoreInformationLink,
	SWTHeader,
	SWTItem,
	SWTMobileHeaders,
	WidgetSecurityInformation,
} from './SecurityWaitTimesWidget';
import {
	Container,
	MainInformationWrapper,
	StyledFlex,
	SWTCardSquircleIcon,
} from './SecurityWaitTimesWidget.styles';
import SecurityIcon from '../../../assets/icons/security.svg';
import { WidgetErrorBanner } from '../../shared/components/widget/WidgetErrorBanner';
import { ErrorMessages } from '../../../utils/errorMessages';

const SecurityWaitTimesWidgetError = ({ onClick }: { onClick: () => void }) => (
	<Container>
		<StyledFlex direction="column" gap="16">
			<Flex direction="row">
				<MainInformationWrapper>
					<MainInformation>
						<SWTHeader />
						<WidgetContent>
							<SWTMobileHeaders />
							{GATES_RANGES?.map((item) => (
								<SWTItem
									key={`${item.min}-${item.max}`}
									data={
										{
											label: `${item.min} - ${item.max}`,
											minWaitSeconds: 0,
											maxWaitSeconds: 0,
										} as ISecurityCheckpoint
									}
								/>
							))}
						</WidgetContent>
						<WidgetSecurityInformation isWidget />
					</MainInformation>
					<MoreInformationLink />
					<MoreInformationButton onClick={onClick} />
				</MainInformationWrapper>
				<SWTCardSquircleIcon icon={<SecurityIcon role="presentation" />} />
			</Flex>
			<WidgetErrorBanner message={ErrorMessages.SecurityWaitTimes} />
		</StyledFlex>
	</Container>
);

export default SecurityWaitTimesWidgetError;
